<template>
  <div id="NewspapersDetais">
    <div class="NewspapersDetais">
      <div class="left_Title">
        <p>
          <i class="iconfont iconjieguo"></i>
          <span class="aqt_lang_mn titlefont">{{ $t('m.details') |U2M }}</span>
        </p>
        <p></p>
      </div>
      <!--      详情-->
      <div class="book_brief">
        <div class="pdfButton" v-if="infosData&&infosData.isannx>0"><img @click="showSelectPdf" src="@/assets/images/pdf.png"></div>
        <div class="left_brief">
          <div class="books_info" v-if="infosData">
            <div class="title">
              <p class="aqt_lang_mn titlefont" v-if="infosData.titlelang && infosData.titlelang.mn ">
                {{
                  infosData.titlelang ? infosData.titlelang.mn ? infosData.titlelang.mn : infosData.titlelang.zh : '' | U2M
                }}
              </p>
              <p class="aqt_su titlefont" v-else>
                {{
                  infosData.titlelang ? infosData.titlelang.zh ? infosData.titlelang.zh : '' : '' | U2M
                }}
              </p>
            </div>
            <div class="aqt_zhengzhuang">
              <p>
                <i class="iconfont iconcishu"></i>
                <span class="contentfont contentfonts1 aqt_lang_mn">{{
                    $t('m.fister_ban')|U2M
                  }} : {{ infosData.edition ? infosData.edition : '' }} {{ $t('m.ci')|U2M }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--pdf-->
      <!--      <div class="book_pdf" v-if="pdfFile">-->
      <!--        <iframe style="width: 100%;height:100%;" :src="'/pdf/web/viewer.html?file=' + pdfFile" frameborder="0"></iframe>-->
      <!--      </div>-->
      <!--      pdf-->
      <!--      <div class="book_pdflist" v-if="pdfList.length">-->
      <!--        <div class="_Title">-->
      <!--          <p>-->
      <!--            <i></i>-->
      <!--            <span class="aqt_lang_mn titlefont">{{ $t('m.Ebook') |U2M }}</span>-->
      <!--          </p>-->
      <!--        </div>-->
      <!--        <div class="_pdflist">-->
      <!--          <div class="list__pdflist" @click="annexChange(item)" v-for="(item,index) in pdfList" :key="index">-->
      <!--            <p class="aqt_lang_mn contentfont">-->
      <!--              {{ item.name ? item.name : '' | U2M }}-->
      <!--            </p>-->
      <!--            <p class="aqt_lang_mn contentfont">{{ change(item.size) }}</p>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      目录-->
      <div class="book_catalogue" v-if="catalogueList.length">
        <div class="_Title">
          <p>
            <i></i>
            <span class="aqt_lang_mn titlefont">{{ $t('m.mulan') |U2M }}</span>
          </p>
        </div>
        <div class="_catalogue">
          <div
              :style="{background:directoryId==item.directory_id?'rgba(0, 0, 0, 0.1)':'',color:directoryId==item.directory_id?'var(--themeColor)':''}"
              class="list_catalogue" v-for="(item,index) in catalogueList" :key="index">
            <p v-if="item.titlelang.mn" class="aqt_lang_mn contentfont" v-html="U2M(item.titlelang.mn)"></p>
            <p v-else class="aqt_su contentfont" v-html="U2M(item.titlelang.zh)"></p>
            <p v-if="item.page" class="aqt_lang_mn contentfont">({{ item.page ? item.page : '' }})</p>
          </div>
        </div>
      </div>

      <!--    加载动画-->
      <AqtSpin v-if="isSpin"></AqtSpin>
      <file_preview style="display:none" :file_name="url" ref="file_preview"></file_preview>
    </div>
<!--    <goback style="top:30px!important;right: 90px!important;"></goback>-->
  </div>
</template>
<script>
export default {
  props: {
    infoId: {
      type: [String, Number],
      default: ''
    },
    directoryId:{
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isSpin: false,
      showPdf: false,
      imgList: [],
      srcList: [],
      pdfList: [],
      catalogueList: [],
      infosData: '',
      url: '',//pdf路径
      pdfFile: '',//pdf路径
    }
  },
  methods: {
    //  获取详情
    getbookDetails() {
      const _this = this;
      _this.isSpin = true
      _this.showPdf = false
      let condition = {
        library_id: _this.library_id,
        id: _this.infoId,
        member_id: _this.member_id,
        ztlx: '',//区分是报社还是报刊
        terminal: _this.$terminal,

        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/newspaperlayout/webfind`, condition)
          .then((val) => {
            if (val.code == 200 && val.data) {
              _this.infosData = val.data
              // if (val.data.isannx) {
              //   //  获取pdf
              //   _this.showSelectPdf()
              // }
              //目录
              _this.getCatalogue()
            } else {
              _this.isSpin = false
            }
          }).catch(e => {
        _this.isSpin = false
      })
    },
    //  获取目录
    getCatalogue() {
      const _this = this;
      let cond = {
        book_id: _this.infoId,
        library_id: _this.library_id,
        type: 3,//1.书目录 2.期刊目录 3报刊 4普通论文 全部不传
        member_id: _this.member_id,
        terminal: _this.$terminal,

        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/directory/newindex`, cond)
          .then((val) => {
            _this.catalogueList = [];
            _this.handelSlugData(val.data, 0);
            _this.isSpin = false
          }).catch((err) => {
        _this.isSpin = false
        _this.catalogueList = [];
      });
    },
    showSelectPdf() {

      let that = this
      let condition = {
        model: 'NewsPaperLayout',
        filetype: 'File',
        level: 'AQT_2023_1',
        id: that.infoId,
        type1: 35,
        name: '报刊详情pdf按钮',
      }
      that.isSpin = true
      // that.pdfFile = ''
      that.$getResources(condition).then((val) => {
        if (val.code == 200) {
          // that.pdfFile = that.$webcrypto.get(val.data)
          that.url = that.$webcrypto.get(val.data)
          if(that.url){
            setTimeout(() => {
              this.$refs.file_preview.preview();
              this.saveUserBehavior(33,'报刊详情pdf资源查看',that.infoId)
            }, 500)
          }

        } else {
          that.$Message.warning({
            content: val.message
          })
        }
        that.isSpin = false
      }).catch((err) => {
        that.isSpin = false
      });
    },
    saveUserBehavior(type, mark, id){
      let that= this

      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      }
      that.$store.dispatch('saveUserBehavior', info).then(() => {
      })

    },
    /************************************************************
     *
     * 处理数据格式
     *
     ************************************************************/
    handelSlugData(data, label) {
      const title = label
      data.map((el, ind) => {
        el.titlelang.mn = (el.titlelang.mn ? `<p class="aqt_lang_mn contentfont" style="height:calc(100% - ${title}px);margin-top:${title}px;"> ${el.titlelang.mn}</p>` : `<p class="aqt_lang_mn contentfont" style="height:calc(100% - ${title}px);margin-top:${title}px;"> ${el.titlelang.zh}</p>`)
        this.catalogueList.push(el)
        let label = title + 20
        if (el.child.length !== 0) this.handelSlugData(el.child, label)
      })
    },
    change(limit) {
      var size = "";
      if (limit < 0.1 * 1024) {                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
      } else if (limit < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB"
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
      } else {                                            //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
      }

      var sizeStr = size + "";                        //转成字符串
      var index = sizeStr.indexOf(".");                    //获取小数点处的索引
      var dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
      if (dou == "00") {                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size;
    },
    //查看pdf
    annexChange(data) {
      this.url = data.url
      setTimeout(() => {
        this.$refs.file_preview.preview();
      }, 500)
    },

  },
  created() {
    this.getbookDetails()
    let info={
      book_id: this.infoId,
      type: 35,
      path: this.$route.path,
      mark: '报刊详情',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  computed: {
    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : "";
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  }
}
</script>

<style lang="less" scoped>
#NewspapersDetais {
  width: 100%;
  height: 100%;
  display: flex;

  .NewspapersDetais {
    width: 100%;
    height: 100%;
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;

    .left_Title {
      min-width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 27px;
      display: flex;
      justify-content: flex-end;

      p:nth-child(1) {
        width: 24px;
        color: var(--themeColor);
        font-size: 20px;
        line-height: 24px;

        i {
          font-size: 24px;
        }
      }

      p:nth-child(2) {
        width: 4px;
        height: 162px;
        background: var(--themeColor);
        margin-left: 10px;
      }
    }

    ._Title {
      width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 35px;
      display: flex;
      justify-content: center;

      p:nth-child(1) {
        width: 24px;
        font-size: 20px;
        line-height: 24px;

        i {
          display: block;
          width: 27px;
          height: 13px;
          background: var(--themeColor);
          margin-bottom: 14px;
        }
      }
    }

    .book_brief {
      //min-width: 200px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding: 27px 10px;
      display: flex;
      position: relative;

      .pdfButton {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 30px;
          height: auto;
          cursor: pointer;
        }
      }

      .left_brief {
        min-width: 55px;
        height: 100%;
        padding-top: 20px;

        .books_info {
          display: flex;
          min-width: 55px;
          padding-top: 10px;
          height: 100%;

          .title {
            height: 100%;
            color: #888888;
            font-size: 1.8rem;
            margin: 0 0.3rem;

            p {
              word-wrap: break-word;
              word-break: normal;
              height: 100%;
            }
          }

          .aqt_zhengzhuang {
            height: 100%;
            color: #888888;
            font-size: 1.2rem;
            margin: 0 .3rem;

            p {
              display: flex;
              flex-direction: column;
              color: #888888;
              font-size: 1.6rem;
              line-height: 1.6rem;
              height: 100%;

              i {
                font-size: 16px;
                margin-bottom: 0.5rem;
              }
            }
          }
        }
      }
    }

    .book_pdf {
      width: 50%;
      height: 100%;
      background: #ffffff;
      //padding-bottom: 5px;
    }

    .book_catalogue {
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._catalogue {
        height: 100%;
        padding: 30px 10px;
        display: flex;
        background: #ffffff;

        .list_catalogue {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          padding: 5px 0;

          p:nth-child(1) {
            height: 92%;
          }

          p:nth-child(2) {
            height: 8%;
            text-align: center;
            margin: 0 auto;
          }
        }

        .list_catalogue:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }

    }

    .book_pdflist {
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._pdflist {
        height: 100%;
        padding: 35px 17px;
        display: flex;
        background: #ffffff;

        .list__pdflist {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          //background: #F2F7FF;
          background: #eeeeee;
          padding: 10px;
          cursor: pointer;

          p:nth-child(1) {
            height: 85%;
          }

          p:nth-child(2) {
            height: 15%;
            text-align: center;
          }
        }

        .list__pdflist:hover {
          color: var(--themeColor);
        }
      }
    }

  }

  .NewspapersDetais::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 12px;
  }

  .NewspapersDetais::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .NewspapersDetais::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>

<style lang="less">
#NewspapersDetais {
  .ivu-carousel {
    height: 100% !important;

    .ivu-carousel-list {
      height: 100% !important;

      .ivu-carousel-track {
        height: 100% !important;

        .ivu-carousel-item {
          height: 100% !important;
        }
      }
    }
  }

  .ivu-carousel-dots li button {
    opacity: unset !important;
    width: 5px !important;
    height: 5px !important;
    border-radius: 50%;
  }

  .ivu-carousel-dots li.ivu-carousel-active > button {
    opacity: unset !important;
    background: var(--themeColor);
  }

  .ivu-carousel-dots-inside {
    bottom: 15px !important;
  }

  //iframe {
  //  #viewer {
  //    background: #ffffff !important;
  //  }
  //
  //  #toolbarContainer {
  //    background: #ffffff !important;
  //  }
  //}

}
</style>
